module.exports = __webpack_public_path__ + "static/media/beachBG.c11f97a3.jpg";